module.exports = __webpack_public_path__ + "static/images/grouping-deliveries.uepyWHU.svg";